@if (isOk) {
  <svg class="system-status-indicator_icon"
    tooltipL10n="components.system-status-indicator.online">
    <use xlink:href="#system-status-indicator-online"></use>
  </svg>
} @else {
  <svg class="system-status-indicator_icon"
    tooltipL10n="components.system-status-indicator.offline">
    <use xlink:href="#system-status-indicator-offline"></use>
  </svg>
}
